module.exports = __webpack_public_path__ + "static/media/img005.641bf832.jpg";